<template>
  <div class="txtbox" :class='{"editTxt":edit}'>
    <div class="txtItem" :style="{'height':Hei || '82px'}">
      <div class="textarea">
        <textarea v-model='contents' @keyup='leave($event)' :disabled='edit' :maxlength="max"></textarea>
        <div class="letter">
          {{content.length}}/{{max}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    Hei: String,
    max: Number,
    content: {
      type: String,
      default() {
        return ''
      }
    },
    edit: Boolean
  },
  data() {
    return {
      contents: ''
    }
  },
  watch: {
    content: {
      handler(newVal) {
        if (newVal && this.content) {
          this.contents = this.content
        }
      },
      immediate: true
    }
  },
  methods: {
    leave(val) {
      this.$emit('contentVal', this.contents)
    }
  }
}
</script>
<style lang="less">
.has-error .txtItem .textarea {
  border-color: #f5222d;
}
</style>
<style lang="less" scoped>
.editTxt {
  background: #f5f5f5;
  .txtItem {
    .textarea {
      background: none;
      border-radius: 4px;
      color: #ccc;
      width: 100%;
      border: 1px solid #d9d9d9;
    }
  }
}
.txtItem {
  display: flex;
  height: 82px;
  position: relative;
}
.textarea {
  border: 1px solid #d9d9d9;
  background: #fff;
  width: 100%;
  padding: 4px 10px 24px;
  border-radius: 4px;
  textarea {
    width: 100%;
    border: 0 none;
    line-height: 20px;
    vertical-align: top;
    height: 100%;
    background: none;
    position: relative;
  }
  .letter {
    position: absolute;
    line-height: 15px;
    font-size: 11px;
    right: 8px;
    bottom: 8px;
  }
}
.onlTxt {
  width: 100%;
}
</style>